import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ListLots from './ListLots.js';
import AddLot from './AddLot.js';
import { Fetch } from '../../utils/Utils.js';
import WhatsAppTip from '../../shared/WhatsAppTip.js';
import { reproLotTips } from '../../shared/whatsappTips.js';
import { ListButton, AddButton, FAB } from '../../shared/ActionButtons';

const formatIatfCode = (lotId, prefix) =>
  lotId != null ? `${prefix}-${String(lotId).padStart(4, '0')}` : '';

export const Lots = ({ screen, setScreen, actions }) => {
  const { t } = useTranslation();
  const [localScreen, setLocalScreen] = useState("list");
  const [protocols, setProtocols] = useState([]);
  const [bulls, setBulls] = useState([]);
  const [defaultProtocolId, setDefaultProtocolId] = useState("");
  const [tip, setTip] = useState(null);

  // Use passed screen/setScreen if provided, otherwise use local state
  const currentScreen = screen !== undefined ? screen : localScreen;
  const setCurrentScreen = setScreen || setLocalScreen;

  useEffect(() => {
    // Fetch protocols
    Fetch("api/data/lots.plans?search_fields=type&search_values=iatf", "get", null,
      (data) => { setProtocols(data || []); },
      () => { console.log("error loading protocols"); }
    );

    // Fetch bulls
    Fetch("api/data/reproduction.bulls", "get", null,
      (data) => { setBulls(data || []); },
      () => { console.log("error loading bulls"); }
    );

    // Fetch account settings to get default protocol
    Fetch("api/data/account.settings", "get", null,
      (data) => {
        if (data && data.length > 0 && data[0].default_protocol_id) {
          setDefaultProtocolId(data[0].default_protocol_id);
        }
      },
      () => { console.log("error loading settings"); }
    );
  }, []);

  return (
    <>
      {actions && <div className="content-header">{actions}</div>}

      {(currentScreen === "list") && (
        <>
          {tip && (
            <WhatsAppTip
              title={tip.title}
              tips={tip.tips}
              onDismiss={() => setTip(null)}
            />
          )}
          <ListLots protocols={protocols} />
          <FAB onClick={() => setCurrentScreen("add")} />
        </>
      )}
      {(currentScreen === "add") &&
        <AddLot
          protocols={protocols}
          bulls={bulls}
          defaultProtocolId={defaultProtocolId}
          onSuccess={(lot) => {
            setCurrentScreen("list");
            const code = formatIatfCode(lot?.lot_id, t('lot_prefix'));
            if (code) {
              setTip({
                title: `✅ ${code} ${t('created')}`,
                tips: reproLotTips(code, t),
              });
            }
          }}
        />
      }
    </>
  );
}

// Action buttons component for use in hub header
export const LotsActions = ({ screen, setScreen }) => (
  <div className="action-buttons">
    <ListButton
      isActive={screen === "list"}
      onClick={() => setScreen("list")}
    />
    <AddButton
      isActive={screen === "add"}
      onClick={() => setScreen("add")}
    />
  </div>
);

export default Lots;
